<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="85%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      // console.log(id, this.entry);
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_STORAGE_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.storage;
          this.extraData = response.data;
          // console.log(this.editableEntry, this.extraData);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(storage) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_STORAGE_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(storage, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateStorage.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
// movementItemAvailableQuantity
const LOAD_STORAGE_QUERY = gql `
  query ($id: ID!) { 
    accountContext {
      storage(id: $id) {
        id
        name
        location
        capacity
        enabledLots
        canBeDeleted
        validations        
        storageItems {
          id
          availableQuantity
          availableTotalPrice
          averageUnitPrice
          itemId
          hasLots
          storageItemLots{
            id
            lotName
            quantity
            packagingQuantity
          }
          item {
            id
            name
            description
            unit {
              name
            }
          }
          packagingId
          packaging {
            id
            name
            size
            text
            unit{
              name
            }
          }
        }
      }
    }
  }
`;

const UPDATE_STORAGE_MUTATION = gql `
  mutation($input: GreenhouseUpdateInputObject!) {
    updateGreenhouse(input: $input) {
      storage {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>